import { __assign } from "tslib";
import * as React from 'react';
import { PermissionsCtx } from '../components/permissions-context/permissions-ctx';
export var withPermissions = function (component) {
    return function (props) {
        return (React.createElement(PermissionsCtx.Consumer, null, function (permissions) {
            return React.createElement(component, __assign(__assign({}, props), { permissions: permissions }));
        }));
    };
};
//# sourceMappingURL=with-permissions.js.map